<template>
  <div class="mission-page">
    <mission-list-pane />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MissionListPane from '@/components/MissionPage/MissionListPane.vue'

/**
 * ミッションページ
 */
export default defineComponent({
  name: 'MissionPage',
  components: { MissionListPane },
})
</script>

<style scoped lang="scss">
.mission-page {
  height: 100%;
}
</style>
